import { inject, Injectable } from '@angular/core';
import {
    BehaviorSubject,
    debounceTime,
    distinctUntilChanged,
    filter,
    map,
    merge,
    mergeAll,
    startWith,
} from 'rxjs';
import { FilterState } from '@ui/shared/domain-filter';

const DEFAULT_MAP_ZOOM = 13;
const ZOOM_CLICK_DEBOUNCE_TIME_IN_MS_TO_PREVENT_FLICKER = 100;

@Injectable({ providedIn: 'root' })
export class MapZoomService {
    protected _filterService = inject(FilterState);

    protected _zoom$ = new BehaviorSubject(DEFAULT_MAP_ZOOM);

    public zoom$ = merge([
        this._zoom$.asObservable()
            .pipe(
                debounceTime(ZOOM_CLICK_DEBOUNCE_TIME_IN_MS_TO_PREVENT_FLICKER),
            ),
        this._filterService.activeFilters$.pipe(
            filter(values => values.size === 0 && this._zoom$.value !== DEFAULT_MAP_ZOOM),
            filter(() => !window.matchMedia('(prefers-reduced-motion: reduce)').matches),
            map(() => DEFAULT_MAP_ZOOM),
        ),
    ])
        .pipe(
            mergeAll(),
            startWith(DEFAULT_MAP_ZOOM),
            distinctUntilChanged(),
        );

    public setZoom(value: number): void {
        this._zoom$.next(value);
    }
}
